import { type PayCardType } from '@webapp/models/enums'
import { type PayEphemeralKey } from '@webapp/models/PayEphemeralKey'
import { type PayCard, type PayCardCustomShippingAddress } from '../models'
import { ApiClient, type IApiRequestParam } from '../services/api'

export const ENDPOINT = '/api/v3/integrations/stripe/cards'
export const CARD_MANAGEMENT_CARDS_URL = ENDPOINT

export interface CreateCardSchema {
  category?: PayCardType
  name: string
  user_id: number
  shipping_address?: PayCardCustomShippingAddress
}

export interface ActivateCardSchema {
  last4?: string
  expiry_date?: string
}

export class CardmanagementCardAPI {
  static readonly getList = (params?) => {
    return ApiClient.get<{}, PayCard[]>(`${CARD_MANAGEMENT_CARDS_URL}/`, {
      params,
    })
  }

  static readonly getCardByCardholderUser = (userID, params?) => {
    return ApiClient.get<{}, PayCard[]>(`${CARD_MANAGEMENT_CARDS_URL}/`, {
      params: {
        cardholder__user: userID,
        ...params,
      },
    })
  }

  static readonly requestCard = (
    data: CreateCardSchema,
    params: IApiRequestParam = {}
  ) =>
    ApiClient.post<CreateCardSchema, PayCard>(
      `${CARD_MANAGEMENT_CARDS_URL}/`,
      data,
      { params }
    )

  static readonly getCardDetails = (
    cardId: PayCard['external_id'],
    params = {}
  ) =>
    ApiClient.get<{}, PayCard>(`${CARD_MANAGEMENT_CARDS_URL}/${cardId}/`, {
      params,
    })

  static readonly updateCard = (
    cardId: PayCard['external_id'],
    card: Partial<PayCard>
  ) =>
    ApiClient.patch<Partial<PayCard>, PayCard>(
      `${CARD_MANAGEMENT_CARDS_URL}/${cardId}/`,
      card
    )

  static readonly activateCard = (
    cardId: PayCard['external_id'],
    activateData: ActivateCardSchema
  ) =>
    ApiClient.patch<ActivateCardSchema, PayCard>(
      `${CARD_MANAGEMENT_CARDS_URL}/${cardId}/activate/`,
      activateData
    )

  static readonly getEphemeralKey = (cardId: PayCard['external_id']) =>
    ApiClient.get<{}, PayEphemeralKey>(
      `${CARD_MANAGEMENT_CARDS_URL}/${cardId}/key/`
    )
}
